export function processBackgroundColor(color: string | undefined): string {
    if (!color) return 'transparent';

    if (color.length === 8) {
        const alphaHex = color.slice(0, 2);
        const rgbHex = color.slice(2);

        if (alphaHex === 'ff') {
            return `#${rgbHex}`;
        } else {
            const alphaDecimal = parseInt(alphaHex, 16) / 255;
            const r = parseInt(rgbHex.slice(0, 2), 16);
            const g = parseInt(rgbHex.slice(2, 4), 16);
            const b = parseInt(rgbHex.slice(4, 6), 16);
            return `rgba(${r}, ${g}, ${b}, ${alphaDecimal})`;
        }
    } else if (color.length === 6) {
        return `#${color}`;
    }

    return 'transparent';
}